'use strict';

var callDateSet = require('../../common/internal/callDateSet');

function setMonth(d, val) {
  callDateSet(d, 'Month', val);
}

module.exports = setMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/setMonth.js
// module id = 536
// module chunks = 0